import * as React from "react";
import { css } from "@emotion/core";
import { ButtonGroup, Button } from "@blueprintjs/core";
import { useSinkState, useSinkActions } from "context/";
import {
  CSS_ZINDEX_MODEL_VIEWER,
  CSS_ZINDEX_MODEL_VIEWER_TOGGLE,
} from "constants/index";

const ModelViewers = () => {
  const { sink, selectedModelId, selectedSurveyId } = useSinkState();
  const { setSelectedModel } = useSinkActions();

  const { models } = sink;
  const selectedModel =
    (selectedModelId && models.find((m) => m.id === selectedModelId)) || null;

  const modelsForSurvey =
    (models &&
      models.filter((model) => model.survey_id === selectedSurveyId)) ||
    [];

  const pointcloud = modelsForSurvey.find(
    (m) => m.type === "potree_pointcloud"
  );

  function setOrNullifyModelId(id: number | null) {
    // obviouly this is a closure over selectedModel
    if (selectedModel && selectedModel.id === id) {
      setSelectedModel(null);
    } else {
      setSelectedModel(id);
    }
  }

  return (
    <ButtonGroup>
      <Button
        text="2D"
        active={selectedModelId === null}
        onClick={() => setSelectedModel(null)}
      />
      <Button
        text="3D"
        active={pointcloud ? selectedModelId === pointcloud.id : false}
        disabled={!pointcloud}
        onClick={() => setOrNullifyModelId(pointcloud.id)}
      />
    </ButtonGroup>
  );
};

const CenterPane = ({ selectedModel }) => {
  return (
    <main>
      <section
        css={css`
          position: absolute;
          left: 10px;
          bottom: 96px;
          z-index: ${CSS_ZINDEX_MODEL_VIEWER_TOGGLE};
        `}
      >
        <ModelViewers />
      </section>
      {selectedModel && (
        <section
          css={css`
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: ${CSS_ZINDEX_MODEL_VIEWER};
          `}
        >
          <ModelViewer model={selectedModel} />
        </section>
      )}
    </main>
  );
};

const ModelViewer = ({ model }) => {
  if (!model) {
    return null;
  }

  const fullEverything = css`
    width: 100%;
    height: 100%;
  `;

  if (model.type === "sketchfab_mesh") {
    return <iframe css={fullEverything} src={model.url} />;
  }

  if (model.type === "potree_pointcloud") {
    return (
      <iframe
        css={fullEverything}
        src={`/potree1.8/potree.html?pc_source=${model.url}`}
      />
    );
  }

  console.warn(`ModelViewer cannot render with model.type == '${model.type}'`);

  return null;
};

export default CenterPane;
